export default {
    name: 'state',
    default: {

    }
}
